/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

function InputField({
  placeholder,
  showSearchIcon,
  onChange,
  customvalue,
  ...props
}) {
  const [inputValue, setInputValue] = useState("");
  useEffect(() => {
    setInputValue(customvalue || "");
  }, [customvalue]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "100%",
          "& input": {
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
          },
          "& .MuiInputLabel-root": {
            display: "none",
          },
        },
        "& .MuiIconButton-root": {
          padding: "0",
        },
      }}
      noValidate
      autoComplete="off"
    >
      {showSearchIcon && (
        <TextField
          id="outlined-basic"
          variant="outlined"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton aria-label="search">
                  <SearchIcon style={{ color: "#1E8BC3" }} />
                </IconButton>
              </InputAdornment>
            ),
            style: { color: inputValue ? "" : "#0A7FDF" },
          }}
        />
      )}
      {!showSearchIcon && (
        <TextField
          id="outlined-basic"
          variant="outlined"
          placeholder={placeholder}
          value={inputValue === "" ? customvalue : inputValue}
          onChange={handleInputChange}
          {...props}
        />
      )}
    </Box>
  );
}

export default InputField;
